import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 9l4 -4l4 4m-4 -4v14","key":"svg-0"}],["path",{"d":"M21 15l-4 4l-4 -4m4 4v-14","key":"svg-1"}]]

/**
 * IconArrowsSort
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3dzLXNvcnQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTMgOWw0IC00bDQgNG0tNCAtNHYxNCIgLz4KICA8cGF0aCBkPSJNMjEgMTVsLTQgNGwtNCAtNG00IDR2LTE0IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/arrows-sort
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowsSort = createReactComponent('outline', 'arrows-sort', 'ArrowsSort', __iconNode);

export default IconArrowsSort;